import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import capitalize from 'common/util/capitalize';

import { getListingSelfShowingLockType } from 'common/listingHelpers';

import SrBox from 'client/components/SrBox';
import SrTourListingFailedModal from 'client/components/SrTourListingFailedModal/SrTourListingFailedModal';
import SrButton, { SR_BUTTON_THEME_ADOBE_YELLOW } from 'client/components/SrButton/SrButton';

import './HitlistTaskListRow.less';

const HitlistTaskListRowBackupCodes = ({ listing, renter, tourListing, getHitlistTasks }) => {
  const selfShowingLockType = getListingSelfShowingLockType(listing);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onSubmit = useCallback(() => {
    setIsModalOpen(false);
    if (!tourListing) {
      global.alert('The tour showing was not found.');
      return;
    }
    if (getHitlistTasks) {
      getHitlistTasks();
    }
  }, [tourListing, getHitlistTasks]);

  return (
    <div styleName="section">
      <span styleName="title">{`${capitalize(selfShowingLockType || '')} Remote Access`}</span>
      <SrBox margin="20px 0" maxWidth="270px">
        <SrButton theme={SR_BUTTON_THEME_ADOBE_YELLOW} onClick={() => setIsModalOpen(true)}>
          Unlock Door Now
        </SrButton>
      </SrBox>
      {tourListing.status && (
        <span styleName="title">Current Tour Status: {capitalize(tourListing?.status)}</span>
      )}
      {tourListing && isModalOpen && (
        <SrTourListingFailedModal
          user={renter}
          listing={listing}
          sunlock={listing.sunlockId}
          codeboxLock={listing.codeboxLockId}
          tourListingId={tourListing.id}
          onSubmit={onSubmit}
        />
      )}
    </div>
  );
};

HitlistTaskListRowBackupCodes.propTypes = {
  listing: PropTypes.object.isRequired,
  renter: PropTypes.object.isRequired,
  tourListing: PropTypes.object,
  getHitlistTasks: PropTypes.func,
};

HitlistTaskListRowBackupCodes.displayName = 'HitlistTaskListRowBackupCodes';

export default HitlistTaskListRowBackupCodes;
